import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import BaseForm from "./Form";
import { ToastMain, SweetAlertShow } from "../master/Master";
import {
  fetchCategories,
  fetchDoc,
  DistributionList,
  Distributionupdate,
  Distributiondelete,
} from "../../api/Documents";
import { imgBaseUrl } from "../../api/api";
import { FiEye } from "react-icons/fi";
import { viewlist } from "../../api/BatchService";
import { getSessions } from "../../api/SessionsService";
import DocumentHeader from "./DocumentHeader";
import { useNavigate } from "react-router-dom";
import {
  GetMarketingSchool,
  MarketingStudentList,
} from "../../api/MarketinService";
import { courseList } from "../../api/Courses";
import { StaffList } from "../../api/Staff";
import Swal from "sweetalert2";

const Distributedlist = () => {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [doc, setDoc] = useState("");
  const [docType, setDocType] = useState("");
  const [type, setType] = useState("student");
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [batch, setBatch] = useState();
  const [selectedBatch, setSelectedBatch] = useState("");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");

  const [selectedStudent, setSelectedStudent] = useState(null);
  const navigate = useNavigate();

  const [sources, setSources] = useState([]);
  const [courses, setCourses] = useState([]);

  const [selectedSource, setSelectedSource] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [status, setStatus] = useState("");
  const [date, setDate] = useState("");

  const openStatusModal = (row) => {
    if (row.distribution_status !== "1") return;
    setSelectedRow(row);
    setStatus("2"); // default collected
    setDate(row.collect_date || "");
    setShowModal(true);
  };

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const categoryFetch = async () => {
    setLoading(true);
    try {
      const response = await fetchCategories();
      if (response.data.status) {
        setCategory(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
       
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    
    }
    setLoading(false);
  };

  const getDoc = async () => {
    setLoading(true);

    let addUrl = `&receiver_type=${type}`;

    if (docType) addUrl += `&doc_type=${docType}`;
    if (selectedCategory) addUrl += `&category=${selectedCategory}`;
    if (search) addUrl += `&search=${search}`;

    if (type === "student" && selectedBatch) {
      addUrl += `&batch_id=${selectedBatch}`;
    }

    if (type === "marketing" && selectedSource) {
      addUrl += `&source_id=${selectedSource}`;
    }

    if (type === "enquiry" && selectedCourse) {
      addUrl += `&course_id=${selectedCourse}`;
    }

    if (type === "staff" && selectedStaff) {
      addUrl += `&staff_id=${selectedStaff}`;
    }

    try {
      const response = await DistributionList(addUrl);
      if (response?.data?.status) {
        setDoc(response.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    categoryFetch();
  }, []);

  const getReceiverData = (row) => {
    switch (type) {
      case "student":
        return {
          name: row?.student?.name,
          phone: row?.student?.phone,
        };

      case "staff":
        return {
          name: row?.staff?.name,
          phone: row?.staff?.mobile,
        };

      case "marketing":
        return {
          name: row?.marketing?.name,
          phone: row?.marketing?.mobile,
        };

      case "enquiry":
        return {
          name: row?.enquiry?.name,
          phone: row?.enquiry?.phone,
        };

      default:
        return {
          name: "N/A",
          phone: "N/A",
        };
    }
  };

  useEffect(() => {
    if (type) {
      getDoc();
    }
  }, [
    type,
    docType,
    search,
    selectedBatch,
    selectedCategory,
    selectedSource,
    selectedCourse,
    selectedStaff,
  ]);

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "no-cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed!");
    }
  };

  // ✅ Handle cleanup when offcanvas is hidden
  useEffect(() => {
    const offcanvasEl = document.getElementById("documentOffcanvas");
    if (!offcanvasEl) return;

    const handleHidden = () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };

    offcanvasEl.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      const response = await viewlist(addUrl);
      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching batches");
    } finally {
      setLoading(false);
    }
  };

  const getSources = async () => {
    const res = await GetMarketingSchool();
    if (res?.data?.status) setSources(res.data.data);
  };

  const getCourses = async () => {
    const res = await courseList();
    if (res?.data?.status) setCourses(res.data.data);
  };

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const res = await StaffList();
      if (res?.data?.status) {
        setStaffList(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedBatch("");
    setSelectedSource("");
    setSelectedCourse("");
    setSelectedStaff("");
    setSearch("");
  }, [type]);

  useEffect(() => {
    if (type === "student") fetchBatches();
    if (type === "marketing") getSources();
    if (type === "enquiry") getCourses();
    if (type === "staff") fetchStaff();
  }, [type]);

  useEffect(() => {
    if (selectedSession) {
      fetchBatches();
    }
  }, [selectedSession]);
const handleStatusUpdate = async () => {
    try {
      const payload = {
        distribution_id: selectedRow.id,
        distribution_status: status,
        collect_date: date,
      };

      const response = await Distributionupdate(payload);

      console.log("Update response:", response);

      ToastMain.fire({
        icon: "success",
        title: "Status updated successfully",
      });

      setShowModal(false);
      // fetchList(); // agar table refresh karni ho
    } catch (err) {
      console.error("Update error:", err);

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ||
          JSON.stringify(err?.response?.data) ||
          "Update failed"
      );
    }
  };

  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete distributed record",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    });

    if (!result.isConfirmed) return;

    try {
      await Distributiondelete({
        distribution_id: row.id,
      });

      ToastMain.fire({
        icon: "success",
        title: "Deleted successfully",
      });

      // fetchList();
    } catch (err) {
      console.error("Delete error:", err);

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ||
          JSON.stringify(err?.response?.data) ||
          "Delete failed"
      );
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
                  <div className="col-md-2 left-pane">
                    <DocumentHeader data={"Documents Portal"} />
                  </div>
                  <div className="col-md-10 right-pane">
                    <div className="card">
                      <div className="card-header align-items-center justify-content-between">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="text-primary m-0">Distribution</h4>

                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => navigate("/documents/distribution")}
                          >
                            Add Distribution
                          </button>
                        </div>

                        {/* Filters Section */}
                        <div className="row g-3">
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline ">
                              <select
                                className="form-control"
                                name="type"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                              >
                                <option value="">Type</option>
                                <option value="student">Student</option>
                                <option value="enquiry">Enquiry</option>
                                <option value="marketing">Marketing</option>
                                <option value="staff">Staff</option>
                              </select>
                              <label>Type</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="mb-3 form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="category_id"
                                value={selectedCategory}
                                onChange={(e) =>
                                  setSelectedCategory(e.target.value)
                                }
                              >
                                <option>Select Category</option>
                                {category?.data?.map((cat, i) => (
                                  <option key={i} value={cat.id}>
                                    {cat?.title}
                                  </option>
                                ))}
                              </select>
                              <label>Document Category</label>
                            </div>
                          </div>

                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="session"
                              value={selectedSession}
                              onChange={(e) =>
                                setSelectedSessions(e.target.value)
                              }
                            >
                              {/* <option value="">Select Session</option> */}
                              {sessions?.map((session) => (
                                <option key={session?.id} value={session?.id}>
                                  {session?.session}:
                                  {session?.status == "1"
                                    ? "Active"
                                    : " Inactive"}
                                  {/* Show "2023-24" */}
                                </option>
                              ))}
                            </select>

                            <label>Filter Session</label>
                          </div>

                          {type === "student" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedBatch}
                                  onChange={(e) =>
                                    setSelectedBatch(e.target.value)
                                  }
                                >
                                  <option value="">Select Batch</option>
                                  {batch?.batches?.map((b) => (
                                    <option key={b.id} value={b.id}>
                                      {b.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch</label>
                              </div>
                            </div>
                          )}

                          {type === "marketing" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedSource}
                                  onChange={(e) =>
                                    setSelectedSource(e.target.value)
                                  }
                                >
                                  <option value="">Select Source</option>
                                  {sources?.map((src) => (
                                    <option key={src.id} value={src.id}>
                                      {src.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Source</label>
                              </div>
                            </div>
                          )}

                          {type === "enquiry" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedCourse}
                                  onChange={(e) =>
                                    setSelectedCourse(e.target.value)
                                  }
                                >
                                  <option value="">Select Course</option>
                                  {courses?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                      {course.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Course</label>
                              </div>
                            </div>
                          )}

                          {type === "staff" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedStaff}
                                  onChange={(e) =>
                                    setSelectedStaff(e.target.value)
                                  }
                                >
                                  <option value="">Select Staff</option>
                                  {staffList?.map((staff) => (
                                    <option key={staff.id} value={staff.id}>
                                      {staff.name}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Staff</label>
                              </div>
                            </div>
                          )}
                          <div className="form-floating form-floating-outline col-md-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              name="search"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <label>Search</label>
                          </div>
                        </div>

                        {/* Table Section */}
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr className="text-center">
                                <th>#</th>
                                <th>Student Name</th>
                                <th>type</th>
                                <th>Category Name</th>
                                <th>Mobile</th>
                                <th>quantity</th>
                                <th>distribution_date</th>
                                <th>Remark</th>
                                <th>collect</th>
                                <th>distribution_status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : doc?.data?.length > 0 ? (
                                doc.data.map((row, index) => {
                                  const receiver = getReceiverData(row);

                                  return (
                                    <tr key={row?.id}>
                                      <td>{index + 1}</td>
                                      <td>{receiver?.name || "N/A"}</td>
                                      <td>{row?.receiver_type}</td>
                                      <td>{row?.category?.title || "N/A"}</td>
                                      <td>{receiver?.phone || "N/A"}</td>
                                      <td>{row?.quantity}</td>
                                      <td>{row?.distribution_date}</td>
                                      <td>{row?.remark}</td>
                                      <td>{row?.collect}</td>
                                      <td>
                                        {row?.distribution_status === "1" && (
                                          <>
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                color: "#8c57ff",
                                              }}
                                              onClick={() =>
                                                openStatusModal(row)
                                              }
                                            >
                                              Distributed
                                            </span>
                                          </>
                                        )}

                                        {row?.distribution_status === "2" && (
                                          <span>
                                            Collect ({row?.collect_date || "-"})
                                          </span>
                                        )}
                                      </td>

                                      <td>
                                        {row?.distribution_status === "1" && (
                                          <span
                                            className="ms-3 text-danger"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleDelete(row)}
                                            title="Delete Distributed Record"
                                          >
                                            <i className="bi bi-trash-fill" />
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                {/* Status */}
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Distributed</option>
                    <option value="2">Collected</option>
                  </select>
                </div>

                {/* Date */}
                <div className="mb-3">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleStatusUpdate}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Distributedlist;
